import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=3491a288&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=3491a288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491a288",
  null
  
)

export default component.exports